// extracted by mini-css-extract-plugin
export default {"wrapper":"InvoiceEditMenu_wrapper__UX4D-","listItem":"InvoiceEditMenu_listItem__QsioU","disabled":"InvoiceEditMenu_disabled__grNXV","link":"InvoiceEditMenu_link__tTrMi"};